import type { ExtractPropTypes, PropType } from 'vue'
import type _Dialog from './dialog.vue'

import { dialogProps } from 'element-plus'

export const sdDialogProps = {
    ...dialogProps,

    // 覆盖默认属性
    draggable       : { type: Boolean, default: true          },

    // 扩展属性
    showFooter      : { type: Boolean, default: true          }, // 显示弹窗底部
    height          : { type: [String, Number] as PropType<string | number>, default: 'auto' }, // 内容高度：设置后内容超出指定高度则滚动显示
    showFullScreen  : { type: Boolean, default: true          }, // 显示全屏按钮
    submitting      : { type: Boolean, default: false         }, // 提交中
    showCancelButton: { type: Boolean, default: true          }, // 显示取消按钮
    cancelButtonText: { type: String , default: '取消'        }, // 取消按钮文字
    showSubmitButton: { type: Boolean, default: true          }, // 显示确认按钮
    submitButtonText: { type: String , default: '确认'        }, // 确认按钮文字
} as const

export type SdDialogProps    = ExtractPropTypes<typeof sdDialogProps>
export type SdDialogInstance = InstanceType<typeof _Dialog>


